var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edg",style:({top:((_vm.line.start.y) + "px")  ,left:((_vm.line.start.x) + "px") , width: (_vm.length + "px") ,    transform: ("rotate(" + _vm.angle + "deg)")})})}
var staticRenderFns = []

export { render, staticRenderFns }